import { useState } from 'react';
import { WorkbookPage, SectionTitle, Callout } from '@/components/WorkbookPage';
import { CalendarClock } from 'lucide-react';

export const IrregularPlannerPage = () => {
  const [expenses, setExpenses] = useState([
    { name: 'Car registration/tags', month: '', annual: '', monthly: '' },
    { name: 'Car maintenance', month: '', annual: '', monthly: '' },
    { name: 'Holiday gifts', month: '', annual: '', monthly: '' },
    { name: 'Birthday gifts', month: '', annual: '', monthly: '' },
    { name: 'Back-to-school', month: '', annual: '', monthly: '' },
    { name: 'Medical/dental', month: '', annual: '', monthly: '' },
    { name: 'Home maintenance', month: '', annual: '', monthly: '' },
    { name: 'Annual subscriptions', month: '', annual: '', monthly: '' },
    { name: 'Pet expenses', month: '', annual: '', monthly: '' },
    { name: 'Clothing replacement', month: '', annual: '', monthly: '' },
    { name: '', month: '', annual: '', monthly: '' },
    { name: '', month: '', annual: '', monthly: '' },
  ]);
  
  const updateExpense = (index, field, value) => {
    const newExpenses = [...expenses];
    newExpenses[index] = { ...newExpenses[index], [field]: value };
    setExpenses(newExpenses);
  };
  
  return (
    <WorkbookPage pageId="irregular-planner" prevPage="emergency-tracker" nextPage="crisis-mode">
      <header className="mb-10">
        <div className="flex items-center gap-3 mb-4">
          <CalendarClock className="h-6 w-6 text-primary" />
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-foreground">
            Irregular Expenses Planner
          </h1>
        </div>
        <p className="text-muted-foreground">
          Plan for expenses that don't happen monthly
        </p>
      </header>
      
      <Callout type="info">
        <strong>Remember:</strong> Annual cost ÷ 12 = monthly set-aside. 
        These aren't emergencies—they're predictable expenses you can prepare for.
      </Callout>
      
      <div className="overflow-x-auto my-6">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-border">
              <th className="text-left py-3 pr-2">Expense</th>
              <th className="text-center py-3 px-2">Month Due</th>
              <th className="text-right py-3 px-2">Annual Cost</th>
              <th className="text-right py-3 pl-2">Monthly Set-Aside</th>
            </tr>
          </thead>
          <tbody>
            {expenses.map((expense, index) => (
              <tr key={index} className="border-b border-border/50">
                <td className="py-2 pr-2">
                  <input
                    type="text"
                    className="w-full bg-muted/30 rounded px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-primary"
                    placeholder="Expense name"
                    value={expense.name}
                    onChange={(e) => updateExpense(index, 'name', e.target.value)}
                  />
                </td>
                <td className="py-2 px-2">
                  <input
                    type="text"
                    className="w-full text-center bg-muted/30 rounded px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-primary"
                    placeholder="Jan, Mar..."
                    value={expense.month}
                    onChange={(e) => updateExpense(index, 'month', e.target.value)}
                  />
                </td>
                <td className="py-2 px-2">
                  <input
                    type="text"
                    className="w-full text-right bg-muted/30 rounded px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-primary"
                    placeholder="$___"
                    value={expense.annual}
                    onChange={(e) => updateExpense(index, 'annual', e.target.value)}
                  />
                </td>
                <td className="py-2 pl-2">
                  <input
                    type="text"
                    className="w-full text-right bg-primary/5 rounded px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-primary"
                    placeholder="$___"
                    value={expense.monthly}
                    onChange={(e) => updateExpense(index, 'monthly', e.target.value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="mt-8 bg-primary/10 rounded-xl p-6">
        <div className="flex items-center justify-between">
          <span className="font-semibold">Total Monthly Set-Aside Needed:</span>
          <input
            type="text"
            className="w-32 bg-card rounded-lg px-4 py-2 text-right text-lg font-bold focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="$___"
          />
        </div>
      </div>
      
      <div className="mt-6 text-sm text-muted-foreground">
        <p><strong>Tip:</strong> Keep this money in a separate savings account or "sinking fund" 
        so it's there when you need it.</p>
      </div>
    </WorkbookPage>
  );
};
